import { render, staticRenderFns } from "./ProductLocalCustomerUpdateForm.vue?vue&type=template&id=74bf9992&"
import script from "./ProductLocalCustomerUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomerUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bf9992')) {
      api.createRecord('74bf9992', component.options)
    } else {
      api.reload('74bf9992', component.options)
    }
    module.hot.accept("./ProductLocalCustomerUpdateForm.vue?vue&type=template&id=74bf9992&", function () {
      api.rerender('74bf9992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductLocalCustomerUpdateForm.vue"
export default component.exports